import { API_URL } from './constants';

export const loadImageWithDimensions = async (url) => {
  try {
    const response = await fetch(url);
    const blob = await response.blob();
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        const img = new Image();
        img.onload = () => resolve({ 
          base64: reader.result, 
          width: img.width, 
          height: img.height, 
          aspectRatio: img.width / img.height 
        });
        img.onerror = () => resolve({ base64: reader.result, width: 100, height: 100, aspectRatio: 1 });
        img.src = reader.result;
      };
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  } catch (error) {
    return null;
  }
};

export const formatNumber = (value, decimals = 0) => {
  if (value === undefined || value === null || isNaN(value)) return '-';
  const num = Math.round(Number(value));
  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
};

export const calcPercentChange = (current, previous) => {
  if (!previous || previous === 0 || current === undefined) return null;
  return ((current - previous) / previous * 100);
};

export const getReportPeriod = (report) => {
  if (report.report_month) {
    return {
      month: report.report_month,
      year: report.report_year || new Date().getFullYear()
    };
  }
  
  if (report.period) {
    const periodStr = report.period;
    const months = ['janvier', 'fevrier', 'mars', 'avril', 'mai', 'juin', 
                    'juillet', 'aout', 'septembre', 'octobre', 'novembre', 'decembre'];
    const lowerPeriod = periodStr.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    
    for (const month of months) {
      if (lowerPeriod.includes(month)) {
        const yearMatch = periodStr.match(/\d{4}/);
        const year = yearMatch ? yearMatch[0] : new Date().getFullYear();
        const monthCapitalized = month.charAt(0).toUpperCase() + month.slice(1);
        return { month: monthCapitalized, year };
      }
    }
    
    const yearMatch = periodStr.match(/\d{4}/);
    if (yearMatch) {
      return { month: 'Annee', year: yearMatch[0] };
    }
  }
  
  return { month: 'Periode', year: new Date().getFullYear() };
};
